// Native
import { useDropzone } from "react-dropzone"
import { useCallback, useEffect, useState } from "react"

// Components
import { Box, Button, ButtonGroup, ModalBody, ModalFooter, Text, useToast } from "@chakra-ui/react"
import { Form, Icon, Modal, Show } from "components"

// Config
import { API } from "config"

export default function Upload({ options, onSuccess = () => {}, ...props }){

    const toast = useToast()
    const [ file, setFile ] = useState()
    const [ form, setForm ] = useState({})
    const [ loading, setLoading ] = useState(false)
    const [ errors, setErrors ] = useState()

    const onDrop = useCallback(files => {
        setFile(files?.[0])
    })

    const { getRootProps, getInputProps, isDragActive, isDragReject, fileRejections } = useDropzone({ 
        onDrop, 
        maxFiles: 1,
        accept: {
            'image/png': ['.png'],
            'image/jpg': ['.jpg'],
            'image/jpeg': ['.jpeg'],
            'text/comma-separated-values': ['.csv'],
            'application/pdf': ['.pdf'],
            'text/html': ['.html', '.htm'],
            'application/msword': ['.doc', '.docx'],
        } 
    })

    const onChange = ({ target }) => {
        const { name, value } = target
        setForm({...form, [name]: value})
    }

    const handleSubmit = async () => {
        setLoading(true)
        setErrors(null)

        try{
            // Monta o formulário
            const _form = new FormData()
            _form.append('file', file)
            
            // Opções adicionais 
            if(form?.label) _form.append('label', form?.label)
            if(options?.customer_id) _form.append('customer_id', options.customer_id)
            if(options?.consultant_id) _form.append('consultant_id', options.consultant_id)
            if(options?.distributor_id) _form.append('distributor_id', options.distributor_id)
            if(options?.order_id) _form.append('order_id', options.order_id)
            if(options?.transaction_id) _form.append('transaction_id', options.transaction_id)

            // Realiza o upload
            await API.post(`/attachments`, _form, { headers: { "Content-Type": "multipart/form-data" } })

            toast({ title: 'Arquivo enviado com sucesso!', status: 'success' })
            onSuccess()
            props?.onClose()
            setForm({})
            setFile(null)
        }catch(err){
            setErrors(err?.response?.data?.errors)
            toast({ title: 'Não foi possível enviar o arquivo.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    useEffect(() => {
        console.log("Rejections", fileRejections)
    }, [fileRejections])

    return(
    <Modal title="Enviar novo arquivo" size="lg" loading={loading} {...props}>
        <ModalBody>

            <Show visible={!!file}>
                <Form.Form onSubmit={handleSubmit}>

                    <Form.Text
                        required
                        isDisabled
                        label="Arquivo:"
                        value={file?.name}
                    />

                    <Form.Text
                        autoFocus
                        label="Rótulo/Descrição:"
                        name="label"
                        value={form.label}
                        error={errors?.label}
                        onChange={onChange}
                        isDisabled={loading}
                        placeholder="Ex.: Documento CNH"
                        helper="Opcional. Ajuda a identificar o arquivo no futuro"
                    />
                    
                </Form.Form>
            </Show>

            <Show visible={!file}>
                <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <Box w="100%" h="200px" borderWidth={3} borderStyle="dashed" borderRadius={8} alignItems="center" justifyContent="center" display="flex" flexDir="column" borderColor={isDragActive ? 'orange' : null}>
                        <Text children={isDragActive ? 'Solte aqui seu arquivo' : 'Arraste seu arquivo para cá'} />
                        <Text fontSize="small" color="GrayText" children="Só é possível enviar arquivos: .pdf, .docx, .csv, .xls, .jpg, .jpeg, .png" />
                    </Box>
                </div>
            </Show>

        </ModalBody>

        <ModalFooter>
            <ButtonGroup size="sm" isDisabled={loading}>
                <Show visible={!!file}>
                    <Button children="Enviar outro arquivo" onClick={() => setFile(null)} leftIcon={<Icon name="refresh" />} />
                    <Button children="Fazer upload" leftIcon={<Icon name="upload" />} colorScheme="orange" isLoading={loading} onClick={handleSubmit} />
                </Show>
                <Show visible={!file}>
                    <Button children="Cancelar" colorScheme="red" onClick={props.onClose} />
                </Show>
            </ButtonGroup>
        </ModalFooter>
    </Modal>
    )
}